import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX_SIGNALS } from '../../../Blocks/SyntheticIndicators/constants'

import './style.scss'

export default class Summary extends Component {
    render() {
        return (
            <div className={'signals-summary'}>
                <FormattedMessage
                    id={`${LOCALE_PREFIX_SIGNALS}.syntheticIndicators.summaryMessage`}
                    values={{
                        a: (chunks) => (
                            <a
                                href="https://source.bisnode.cz/data/gnosus/D&B_CZ&SK-Definice_signalu-Signals_Description.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="signals-summary-link"
                            >
                                {chunks}
                            </a>
                        ),
                    }}
                />
            </div>
        )
    }
}
